import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faAngellist } from '@fortawesome/free-brands-svg-icons/faAngellist';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: '/',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: '/',
    label: 'Facebook',
    icon: faFacebookF,
  },
  {
    link: '/',
    label: 'Instagram',
    icon: faInstagram,
  },
  {
    link: 'https://www.linkedin.com/in/timothydemonbreun/',
    target: '_blank',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: '/',
    label: 'Angel List',
    icon: faAngellist,
  },
  {
    link: '/',
    label: 'Twitter',
    icon: faTwitter,
  },
  {
    link: 'mailto:m@timothyd.site',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
